import React from "react";
import "bootstrap-icons/font/bootstrap-icons.css";
import {Button, ToggleButton, ToggleButtonGroup} from "react-bootstrap";
import {BsLayersHalf} from "react-icons/bs";
import {useOverlayContext} from "../../contexts/OverlayContext";
import {useFileDataset} from "../../hooks/useJsonLoader";
import {OverlayType} from "../../types/enums";

import "../../css/ui.css";
import {UIBottomLeft, UITopLeft, UITopRight} from "../layout/UI";
import ListLinkButton from "../ListLinkButton";
import NetworkLinkButton from "../NetworkLinkButton";
import Screenshot from "../SigmaScreenshot";
import OverlayLegend from "./OverlayLegend";
import OverlayModal from "./OverlayModal";
import OverlayDownload from "./OverlayDownload";

const OverlayUserInterface = () => {
  const {overlayResults, showModal, overlayType, setOverlayType, triggerProcessOverlay} = useOverlayContext();
  const dataset = useFileDataset();

  const handleOverlayTypeChange = (value: OverlayType) => {
    return () => {
      setOverlayType(value);
      triggerProcessOverlay();
    };
  }

  return <>
    <OverlayModal/>

    <UITopLeft>
      <NetworkLinkButton/>
      <ListLinkButton/>
    </UITopLeft>

    <UITopRight>
      <ToggleButtonGroup
        type="radio"
        name="overlay-radio"
        value={overlayType}
        onChange={(value) => handleOverlayTypeChange(value as OverlayType)()}
      >
        <ToggleButton id="tbg-radio-1" variant="outline-light" value={OverlayType.SAFE}>SAFE</ToggleButton>
        <ToggleButton id="tbg-radio-2" variant="outline-light" value={OverlayType.RISK}>RISK</ToggleButton>
      </ToggleButtonGroup>

      <Button variant="outline-light" onClick={showModal}>
        <div className="d-none d-sm-block">Overlay Data</div>
        <div className="d-block d-sm-none"><BsLayersHalf/></div>
      </Button>
    </UITopRight>

    <UIBottomLeft direction="row" align="end" allowScreenshot>
      <div className="d-flex flex-column-reverse gap-2" data-html2canvas-ignore>
        <OverlayDownload/>
        <Screenshot
          fileName="thecellmap_enrichment_overlay"
          overlayResults={overlayResults}
          dataset={dataset ?? undefined}
          data-html2canvas-ignore
        />
      </div>
      {!!overlayResults && <OverlayLegend/>}
    </UIBottomLeft>
  </>
}

export default OverlayUserInterface;
